import { render, staticRenderFns } from "./SectionHover.vue?vue&type=template&id=21f50a21&"
import script from "./SectionHover.vue?vue&type=script&lang=js&"
export * from "./SectionHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports